<template>
  <a-layout id="components-layout-demo-fixed-sider">
    <a-layout-sider
      :style="{ overflow: 'auto', height: '100vh', position: 'fixed', left: 0 }"
      class="sider-main"
    >
      <div class="logo" />
      <support-sider v-on:getFileObj="getFileObj" />
    </a-layout-sider>
    <a-layout :style="{ marginLeft: '256px' }">
      <a-layout-header
        :style="{ background: '#fff', padding: 0 ,'padding-right':'30px','text-align':'right'}"
        :align="center"
      >
        <a-icon type="user" :style="{color:'#1890ff','padding-right':'10px'}" />
        <span>{{userName}}</span>
        <a-button type="link" @click="loginOut">退出</a-button>
      </a-layout-header>
      <a-layout-content :style="{ margin: '24px 16px 0', overflow: 'initial' }">
        <div :style="{ padding: '24px', background: '#fff', width:'80%', margin:'0 auto'}">
          <support-main :fileInfo="fileInfo" class="support-main" />
        </div>
      </a-layout-content>
      <a-layout-footer :style="{ textAlign: 'center'}">Dingli Suppport ©2020 Created by Dingli</a-layout-footer>
    </a-layout>
  </a-layout>
</template>


<script>
import SupportSider from "./components/SupportSider";
import SupportMain from "./components/SupportMain";

export default {
  name: "App",
  components: {
    SupportSider,
    SupportMain,
  },
  data() {
    return {
      fileInfo: [],
      supportUser: [],
    };
  },
  created: function () {
    this.axios
      .post("getUser.php")
      .then((response) => this.checkLogin(response.data));
  },
  methods: {
    getFileObj(Category) {
      if (Category != false) {
        this.axios
          .post(
            "product.php",
            "id=" + Category.key
          )
          .then((response) => (this.fileInfo = response.data.res));
      }
    },
    loginOut() {
      window.location.href = "loginout.php";
    },
    checkLogin(data) {
      if (data.state == 1) {
        this.userName = data.res;
      } else {
        window.location.replace("login.php");
      }
    },
  },
};
</script>
<style>
#components-layout-demo-fixed-sider .logo {
  height: 45px;
  background-image: url("./assets/images/logo.png");
  background-repeat: no-repeat;
  margin: 15px auto;
}
.sider-main {
  max-width: 256px !important;
  width: 256px !important;
}
.support-main {
  min-height: 800px;
}
</style>
